import styled, { css } from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export const IconWrap = styled.div`
	width: 28px;
	height: 28px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	margin-top: 1px;
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
`;

export const Item = styled(DropdownMenu.Item)<{ $disabled?: boolean }>`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 6px;
	outline: none;
	user-select: none;

	&[data-highlighted] {
		background: ${({ theme, $disabled }) => ($disabled ? 'transparent' : theme.gray[200])};
	}

	${({ $disabled }) =>
		$disabled &&
		css`
			opacity: 0.45;
		`}
`;

export const Text = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const Label = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const Description = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
`;
